import React from "react";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import {StyledBox, StyledModal} from "../../style/Common/Delete"

const DeleteConfirmationModal = ({ open, onClose, onConfirm }) => {
  return (
    <StyledModal open={open} onClose={onClose}>
      <StyledBox
        onClick={(e) => e.stopPropagation()}
      >
        <div className="icon-wrapper">
          <DeleteForeverIcon />
        </div>
        <h2 className="title">Are you sure you want to delete this?</h2>
        <p className="sub-text">This action can't be undone!</p>
        <div className="button-group">
          <button className="delete-button" onClick={onConfirm}>Delete</button>
          <button className="cancel-button" onClick={onClose}>Cancel</button>
        </div>
      </StyledBox>
    </StyledModal>
  );
};
export default DeleteConfirmationModal;
